import React from "react";
import { Link } from "react-router-dom";
import { LogoutIcon } from "../../../../app/components/jds/icons";

// Atalho redundante do "Sair" do menu do usuário. `title` nativo de propósito:
// um OverlayTrigger aqui jogaria o tooltip em document.body e fecharia o
// Dropdown do usuário no mesmo clique (ver ThemeToggle).
export function LogoutButton() {
  return (
    <div className="topbar-item">
      <Link
        to="/logout"
        className="btn btn-icon btn-clean btn-lg ml-1"
        title="Sair"
        aria-label="Sair"
      >
        <span className="svg-icon">
          <LogoutIcon />
        </span>
      </Link>
    </div>
  );
}
